<dims class="{props.orientation} {props.sizeClass}">
  <div class="small">S</div>
  <div class="medium">M</div>
  <div class="large">L</div>

  {cap(t('dimensions'))}
</dims>
